module.exports = __webpack_public_path__ + "static/media/create-user-icon.243b55ee.svg";